import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    .compass-container {
        justify-content: center;
    }

    ds-compass {
        display: block;
        height: 100%;
        overflow-y: hidden;
        overflow-x: hidden;
    }

    .container {
        height: 100%;
    }

    .body {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .overlay {
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        grid-template-columns: auto 1fr auto;
        display: grid;
        height: 100%;
    }

    .info {
        align-self: flex-end;
        justify-self: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 1rem;
    }

    .bearing {
        font-size: smaller;
    }

    .hidden {
        visibility: hidden;
    }

    #left.straight {
        transform: rotate(90deg);
    }

    #right.straight {
        transform: rotate(-90deg);
    }

    sl-icon {
        font-size: 5em;
        align-self: center;
    }
`;
